export const configuration = {
        client_id: process.env.REACT_APP_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI,
        scope: "openid profile email",
        authority: "https://sso.mylogin.utah.gov",
        service_worker_relative_url: "/OidcServiceWorker.js",
        service_worker_only: true,
    };

